import { render } from "./ListAROrdersActionButtonsRenderer.vue?vue&type=template&id=6aa53ba0"
import script from "./ListAROrdersActionButtonsRenderer.vue?vue&type=script&lang=js"
export * from "./ListAROrdersActionButtonsRenderer.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__